import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    TaxService,
} from './';

let ENTITY_STATES = [
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
    ],
    entryComponents: [
    ],
    providers: [
        TaxService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiTaxModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/tax/tax.module.ts